export const Role = {
  Admin: 'admin',
  Redactor: 'redactor'
}
